'use client'

import cn from 'classnames'
import Link from 'next/link'
import { useEffect, useMemo, useState } from 'react'

import { Button } from '@/components/Button'
import { DualImageSwiper } from '@/components/DualImageSwiper'
import { Image } from '@/components/Image'

export default function Page() {
  return (
    <main>
      {/* MV */}
      <section data-id="HeaderKey" className="relative">
        <div className="hidden md:block">
          <DualImageSwiper
            leftImages={[
              {
                src: '/tokyo-01.jpg',
                alt: '東京オフィス 1',
                width: 1200,
                height: 1200,
              },
              {
                src: '/tokyo-02.jpg',
                alt: '東京オフィス 2',
                width: 1200,
                height: 1200,
              },
              {
                src: '/tokyo-03.jpg',
                alt: '東京オフィス 3',
                width: 1200,
                height: 1200,
              },
            ]}
            rightImages={[
              {
                src: '/nagoya-01.jpg',
                alt: '名古屋オフィス 1',
                width: 1200,
                height: 1200,
              },
              {
                src: '/nagoya-02.jpg',
                alt: '名古屋オフィス 2',
                width: 1200,
                height: 1200,
              },
              {
                src: '/nagoya-03.jpg',
                alt: '名古屋オフィス 3',
                width: 1200,
                height: 1200,
              },
            ]}
          />
        </div>
        <div className="aspect-[3/1] md:hidden">
          <Image
            src="/top-01-mobile.jpg"
            alt=""
            width={800}
            height={2400}
            className="w-full object-cover"
          />
        </div>
        <h2 className="absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 text-center">
          <span className="inline-block bg-primary/75 px-4 py-3 text-2xl leading-snug text-white md:p-4 md:text-4xl md:leading-none">
            変わり続ける時代を、
            <br className="md:hidden" />
            ともに歩む
          </span>
        </h2>
        <div className="absolute right-[10vw] top-0 size-[10vw] bg-primary md:right-[5vw] md:size-[5vw]" />
        <div className="absolute right-0 top-[10vw] size-[10vw] bg-white md:top-[5vw] md:size-[5vw]" />
        <div className="absolute right-0 top-[30vw] size-[10vw] bg-primary md:top-[15vw] md:size-[5vw]" />

        <div className="absolute bottom-0 left-0 size-[10vw] bg-primary md:size-[5vw]" />
        <div className="absolute bottom-[10vw] left-[10vw] size-[10vw] bg-white md:bottom-[5vw] md:left-[5vw] md:size-[5vw]" />
      </section>

      {/* ABOUT */}
      <section className="my-12 md:my-30">
        <div className="relative grid grid-rows-[auto_1fr_auto] gap-x-12 px-lg md:grid-cols-12">
          <div className="row-start-2 row-end-3 md:col-span-5 md:row-span-2">
            <Image
              src="/about-01.jpg"
              alt=""
              width={1200}
              height={1200}
              className="my-6 object-cover md:my-0 md:min-w-[calc(100%+4vw)] md:-translate-x-lg"
            />
          </div>
          <div className="row-span-1 md:col-start-6 md:col-end-13 xl:col-end-11">
            <h3 className="mb-5 font-sans text-base font-bold tracking-widest text-primary md:mb-8 md:mt-2 md:text-xl">
              ABOUT
            </h3>
            <h3 className="font-serif text-xl font-bold leading-normal tracking-wider md:mb-4 md:text-2xl 2xl:text-2.5xl">
              確定申告から法人税務まで、
              <br />
              最新の知識と経験で未来を支える。
            </h3>
          </div>
          <div className="row-span-1 md:col-start-6 md:col-end-13 xl:col-end-11">
            <p className="text-sm leading-loose text-body-65 md:text-base">
              堀口会計は、確定申告から法人税務、経営に関するアドバイスまで幅広く対応します。最新の専門知識と豊富な実績を活かし、フリーランスから企業まで幅広くサポート。AIやクラウド会計などの技術も積極的に取り入れ、事業が次のステージへ進む力となれるよう伴走し続けます。
            </p>
            <div className="mt-4 inline-block text-sm md:mt-6 md:text-base">
              <Button href="/about" text="堀口会計について" color="white" />
            </div>
          </div>
          <div className="relative hidden md:col-start-11 md:col-end-13 md:block 2xl:col-start-10">
            <Image
              src="/about-02.jpg"
              alt=""
              width={600}
              height={600}
              className="absolute bottom-0 right-0"
            />
          </div>
        </div>
      </section>
      {/* SERVICE */}
      <section className="my-12 border-t pt-12 border-primary-25 md:my-30 md:border-t-0 md:pt-0">
        <div className="grid grid-cols-12 gap-x-lg px-lg md:gap-x-12 md:gap-y-10">
          <div className="col-span-12 mb-6 md:mb-0 xl:col-span-4">
            <h3 className="mb-5 font-sans text-base font-bold tracking-widest text-primary md:mb-8 md:mt-2 md:text-xl">
              SERVICE
            </h3>
            <h3 className="mb-2 font-serif text-xl font-bold leading-normal tracking-wider md:mb-4 md:text-2xl 2xl:text-2.5xl">
              フリーランスから法人まで、
              <br />
              税務の不安をトータルサポート
            </h3>
            <p className="max-w-2xl text-sm leading-loose text-body-65 md:text-base">
              個人事業主やフリーランスの方に向けた確定申告・税務相談から、中小企業・法人のお客様に向けた税務顧問や会計業務のご支援まで、幅広いサービスを提供しています。
            </p>
            <div className="mt-6 hidden gap-4 md:flex xl:grid">
              <div>
                <Button
                  href="/service/tax-return"
                  text="確定申告の税務顧問"
                  color="white"
                />
              </div>
              <div>
                <Button
                  href="/service/tax-advisor"
                  text="企業の税務顧問"
                  color="white"
                />
              </div>
            </div>
          </div>
          <Link
            href="/service/tax-return"
            className="group relative col-span-6 flex aspect-square flex-col items-center justify-center rounded border border-body-25 md:rounded-lg xl:col-span-4"
          >
            <div className="absolute inset-0 size-full bg-primary/10 opacity-0 transition-opacity group-hover:opacity-100"></div>
            <p>
              <span className="material-symbols-outlined !text-[40px] text-primary md:!text-[64px]">
                contract
              </span>
            </p>
            <h2 className="mt-3 text-sm font-medium md:mt-6 md:text-xl">
              確定申告の税務顧問
            </h2>
            <h2 className="text-gothic mt-fz-1 text-xxs tracking-widest text-body-50 md:text-sm">
              Tax Return
            </h2>
            <div className="absolute -bottom-0.25 -right-0.25 flex size-6 items-center justify-center rounded bg-primary md:size-10 md:rounded-lg">
              <span className="material-symbols-outlined !text-[12px] text-white md:!text-[16px]">
                arrow_forward
              </span>
            </div>
          </Link>
          <Link
            href="/service/tax-advisor"
            className="group relative col-span-6 flex aspect-square flex-col items-center justify-center rounded border border-body-25 md:rounded-lg xl:col-span-4"
          >
            <div className="absolute inset-0 size-full bg-primary/10 opacity-0 transition-opacity group-hover:opacity-100"></div>
            <p>
              <span className="material-symbols-outlined !text-[40px] text-primary md:!text-[64px]">
                apartment
              </span>
            </p>
            <h2 className="mt-3 text-sm font-medium md:mt-6 md:text-xl">
              企業の税務顧問
            </h2>
            <h2 className="text-gothic mt-fz-1 text-xxs tracking-widest text-body-50 md:text-sm">
              Tax Advisor
            </h2>
            <div className="absolute -bottom-0.25 -right-0.25 flex size-6 items-center justify-center rounded bg-primary md:size-10 md:rounded-lg">
              <span className="material-symbols-outlined !text-[12px] text-white md:!text-[16px]">
                arrow_forward
              </span>
            </div>
          </Link>
        </div>
      </section>
    </main>
  )
}
